import { AgGridReactProps } from '@ag-grid-community/react';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ApiConnectionFirmMapping } from '@tassat/fred-extended-definitions';
import { Lock as LockIcon } from '@tassat/icon';
import React from 'react';
import { LinkProps, Link as RouterLink } from 'react-router-dom';

import { LOCK_ICON_COLOR } from 'Lib/constant';
import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

const Link = (RouterLink as unknown) as React.ComponentClass<LinkProps>;

interface IApiConnectionListItemProps extends AgGridReactProps {
    data: ApiConnectionFirmMapping;
    cellHeight: number;
}

const muiStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    root: {
        height: (props: IApiConnectionListItemProps) => props.cellHeight - 2,
        paddingLeft: '1.5rem',
        color: 'inherit',
        textDecoration: 'inherit',
        backgroundColor: (props: IApiConnectionListItemProps) => (props.data.apiFirm.IsLocked ?
            theme?.app?.applicationColors.tableRowWarningColor || 'rgba(245,130,74,0.16)'
            : theme?.app?.applicationColors.enumColors.white || '#fff'),
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme?.app?.applicationColors.enumColors.offWhite ||
                '#F3F3F3'
        }
    },
    name: {
        fontSize: '1rem',
        paddingTop: '.75rem',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        color: theme?.app?.clientTheme.colors.primaryColor ||
            '#375073'
    },
    sourceId: {
        fontSize: '.8rem',
        color: theme?.app?.applicationColors.fontColor ||
            '#202020'
    }
}));

export function ApiConnectionCellRenderer(props: IApiConnectionListItemProps) {
    const { data } = props;

    const {
        apiConnection,
        apiFirm,
        firm
    } = data;

    const {
        root,
        name,
        sourceId
    } = muiStyles(props);

    return (
        <Grid
            className={`${root} api-connection-cell`}
            component={Link}
            container
            direction='row'
            title={(apiConnection?.APIConnectionName?.length ?? 0) > 36 ? apiConnection.APIConnectionName : null}
            to={`/admin/firms/${firm.FirmId}/api/${apiFirm.APIConnectionFirmId}`}
        >
            <Grid
                container
                direction='column'
                item
                xs={10}
            >
                <Typography
                    className={name}
                    variant='h4'
                ><strong>{apiConnection?.APIConnectionName}</strong>
                </Typography>
                <Typography
                    className={sourceId}
                    variant='body2'
                >{apiConnection?.SourceId}
                </Typography>
            </Grid>
            <Grid
                alignItems='center'
                container
                direction='column'
                item
                justifyContent='center'
                spacing={0}
                xs={2}
            >
                {apiFirm.IsLocked &&
                    <LockIcon iconColor={LOCK_ICON_COLOR} />}
            </Grid>
        </Grid>
    );
}

export default (ApiConnectionCellRenderer);